import { FieldValues } from 'react-hook-form'
import {
  EVENT_ACTION_BLURRED,
  EVENT_ACTION_CHANGED,
  EVENT_ACTION_FOCUSED,
  EVENT_PROPERTY_ACTION,
  EVENT_PROPERTY_DESCRIPTOR,
  EVENT_PROPERTY_UI_CONTEXT,
  EVENT_SELECT_INTERACTION,
} from '../../utils/analytics/events'
import { useAnalytics } from '../components/Analytics'
import { SelectProps } from '../components/Select/Select'

export const useSelectProps = <TFormValues extends FieldValues>(
  props: SelectProps<TFormValues>
) => {
  const { analytics } = useAnalytics()
  const { tracking, onFocus, onBlur, onChange, ...restSelectProps } = props

  const handleFocus = (e: React.FocusEvent<HTMLSelectElement>) => {
    analytics?.track(EVENT_SELECT_INTERACTION, {
      [EVENT_PROPERTY_ACTION]: EVENT_ACTION_FOCUSED,
      [EVENT_PROPERTY_DESCRIPTOR]: tracking?.descriptor,
      [EVENT_PROPERTY_UI_CONTEXT]: tracking?.ui_context,
    })

    if (onFocus) {
      onFocus(e)
    }
  }

  const handleBlur = (e: React.FocusEvent<HTMLSelectElement>) => {
    analytics?.track(EVENT_SELECT_INTERACTION, {
      [EVENT_PROPERTY_ACTION]: EVENT_ACTION_BLURRED,
      [EVENT_PROPERTY_DESCRIPTOR]: tracking?.descriptor,
      [EVENT_PROPERTY_UI_CONTEXT]: tracking?.ui_context,
    })

    if (onBlur) {
      onBlur(e)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    analytics?.track(EVENT_SELECT_INTERACTION, {
      [EVENT_PROPERTY_ACTION]: EVENT_ACTION_CHANGED,
      [EVENT_PROPERTY_DESCRIPTOR]: tracking?.descriptor,
      [EVENT_PROPERTY_UI_CONTEXT]: tracking?.ui_context,
      value: e.target.value,
    })

    if (onChange) {
      onChange(e)
    }
  }

  return {
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: handleChange,
    ...restSelectProps,
  }
}
